"use client"

import { motion } from "framer-motion"
import useOrientation from "@/hooks/useOrientation"
import Topnav from "@/components/topnav"

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
}

export default function InicioPage() {
  const { isPortrait, isLandscape, isStandalone } = useOrientation()

  return (
    <div
      className="
        relative w-full h-[100dvh]
        overflow-hidden overscroll-none
        touch-pan-y
        bg-black
      "
    >
      <Topnav />

      <section
        className={`
          inset-0 flex flex-col overflow-hidden
          w-full select-none

          ${isLandscape ? "bg-[var(--movil-nav)] h-[calc(100%-3.7rem)] rounded-xl" : ""}
          ${isPortrait ? "h-[100dvh] pb-0 mb-0" : ""}
          ${isStandalone ? "h-[100dvh] mb-40" : ""}
        `}
      >
        <div
          className="
            w-full h-full
            overflow-hidden
            rounded-xl
            flex flex-col
          "
        >
          {/* IFRAME CONTAINER PRO */}
          <motion.div
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="
              w-full
h-full
              overflow-hidden
              rounded-xl
              relative
              contain-content

              /* efecto pro */
              bg-gradient-to-b from-white/5 to-white/0
              backdrop-blur-xl
              border border-white/10
              shadow-[0_0_40px_rgba(255,255,255,0.05)]
            "
          >
            {/* Glow dinámico detrás */}
            <div
              className="
                absolute inset-0 -z-10
                bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.08),transparent_70%)]
              "
            />

            {/* Borde animado */}
            <div
              className="
                absolute inset-0 pointer-events-none rounded-xl
                border border-transparent
                [mask-image:linear-gradient(white,transparent)]
                animate-[pulse_3s_ease-in-out_infinite]
              "
            />

            {/* IFRAME */}
            <iframe
              src="/frames/atropos-mixtape/index.html"
              title="Promote"
              className="
                w-full h-full
                border-none
                overflow-hidden
                rounded-xl

                /* efecto 3D suave */
                transition-transform duration-500
                hover:scale-[1.01]
                hover:shadow-[0_0_60px_rgba(255,255,255,0.15)]
              "
            />
          </motion.div>
        </div>
      </section>
    </div>
  )
}
